import { render, staticRenderFns } from "./_partyBody.vue?vue&type=template&id=5fd6f313&scoped=true"
import script from "./_partyBody.vue?vue&type=script&lang=js"
export * from "./_partyBody.vue?vue&type=script&lang=js"
import style0 from "./_partyBody.vue?vue&type=style&index=0&id=5fd6f313&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fd6f313",
  null
  
)

export default component.exports